import { Badge, Box, Button, Stack } from "@justworkshr/milo-core";
import {
  CUSTOMER_IO_CTA_CLICK_EVENT,
  sendCustomerIOEvent,
} from "app/customer-io";
import { oktaAuth, pkceIsEnabled } from "app/okta";
import { useGetFeatureFlag } from "lib/launch-darkly";
import { ReactElement } from "react";
import { useGetCompanyDisplayQuery } from "types/generated/operations";
import { CF_ADD_CONTRACTOR_LINK, CONTRACTOR_PRICE } from "../../constants";
import styles from "../../InternationalSolutionsPage.module.css";

const ContractorPriceCard = (): ReactElement => {
  const { mdHead, hr, smFont, secondaryFont, xlFont, badgeContainer } = styles;

  const accessToken = pkceIsEnabled() ? oktaAuth.getAccessToken() : "";
  const { data: memberData } = useGetCompanyDisplayQuery();
  const { getFeatureFlag } = useGetFeatureFlag();

  const isIcpPdpPromoCampaignEnabled = getFeatureFlag("icp-pdp-promo-campaign");

  const triggerCustomerIOEvent = (ctaName: string, nextUrl: string) => {
    sendCustomerIOEvent(
      {
        event_type: CUSTOMER_IO_CTA_CLICK_EVENT,
        member_uuids: [memberData?.authenticatedMember.uuid ?? ""],
        company_uuids: [memberData?.authenticatedMember.company.uuid ?? ""],
        data: {
          current_url: window.location.href,
          cta_name: ctaName,
          next_url: nextUrl,
        },
      },
      accessToken
    );
  };

  return (
    <Box
      backgroundColor="neutral"
      border={{
        borderColor: "neutralSubtle",
        borderRadius: "md",
        borderWidth: "sm",
      }}
      padding="md"
    >
      <Stack spacing="md">
        <Stack spacing="2xs">
          <p className={mdHead}>Pricing</p>
          <p className={smFont}>
            Only pay for months when you paid a contractor.
          </p>
        </Stack>
        <hr className={hr}></hr>
        <Stack spacing="lg">
          <Stack spacing="2xs">
            {/* TODO: Remove this once the promo campaign is over https://justworks-tech.atlassian.net/browse/IEORN-6051 */}
            {isIcpPdpPromoCampaignEnabled ? (
              <>
                <span className={badgeContainer}>
                  <Badge role="positive">Special offer</Badge>
                </span>
                <p className={xlFont}>
                  <s>$39</s> $0/month per paid international contractor
                </p>
                <p className={`${smFont} ${secondaryFont}`}>
                  Offer valid until March 31, 2026. Foreign exchange fees may
                  still apply.
                </p>
              </>
            ) : (
              <>
                <p className={xlFont}>{CONTRACTOR_PRICE}</p>
                <p className={`${smFont} ${secondaryFont}`}>
                  Great for flexible, short-term work
                </p>
              </>
            )}
          </Stack>
          <Button
            data-heap-id="add-contractor-button"
            color="brand"
            type="button"
            as="a"
            size="md"
            href={CF_ADD_CONTRACTOR_LINK}
            onClick={() =>
              triggerCustomerIOEvent(
                "eor_contractors_add_contractor_button",
                CF_ADD_CONTRACTOR_LINK
              )
            }
          >
            Add contractor
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default ContractorPriceCard;
